// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SideMenu-sideNavItemInnerFlex-pjmbR {
    display: -webkit-inline-box;
    display: -ms-inline-flexbox;
    display: inline-flex;
    -webkit-box-pack: justify;
        -ms-flex-pack: justify;
            justify-content: space-between;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    width: 100%;
    gap: 10px;
}`, "",{"version":3,"sources":["webpack://./src/components/ManageListing/SideMenu/SideMenu.css"],"names":[],"mappings":"AAAA;IACI,2BAAoB;IAApB,2BAAoB;IAApB,oBAAoB;IACpB,yBAA8B;QAA9B,sBAA8B;YAA9B,8BAA8B;IAC9B,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,WAAW;IACX,SAAS;AACb","sourcesContent":[".sideNavItemInnerFlex {\n    display: inline-flex;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n    gap: 10px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sideNavItemInnerFlex": `SideMenu-sideNavItemInnerFlex-pjmbR`
};
module.exports = ___CSS_LOADER_EXPORT___;
